<template>
  <div class="new-feaure-wrapper">
    <div class="title">
      <span class="fa fa-map-marker icon"></span> 新增线要素
      <span class="fa fa-times" @click="toggleNewFeaturePanel"></span>
    </div>
    <div class="content">
      <div class="item">
        <span class="tip">要素类型</span>
        <el-select v-model="type" size="mini" placeholder="请选择">
          <el-option
            v-for="item in featureTypeOptions"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span class="tip">资源id:</span>
        <el-input
          v-model="resoure"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">名称:</span>
        <el-input
          v-model="name"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">镇ID:</span>
        <el-input
          v-model="town"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">村ID:</span>
        <el-input
          v-model="village"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">地址:</span>
        <el-input
          v-model="location"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">经度:</span>
        <el-input v-model="lon" placeholder="请输入内容" size="mini"></el-input>
      </div>
      <div class="item">
        <span class="tip">纬度:</span>
        <el-input v-model="lat" placeholder="请输入内容" size="mini"></el-input>
      </div>
      <div class="item">
        <span class="tip">规制:</span>
        <el-input v-model="gz" placeholder="请输入内容" size="mini"></el-input>
      </div>
      <div class="item">
        <span class="tip">历史文脉:</span>
        <el-input
          v-model="lswm"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">传承方案:</span>
        <el-input
          v-model="ccfa"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">简介:</span>
        <el-input v-model="des" placeholder="请输入内容" size="mini"></el-input>
      </div>
      <div class="item">
        <span class="tip">级别:</span>
        <el-input
          v-model="level"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">图片:</span>
        <el-input
          v-model="picture"
          placeholder="请输入内容"
          size="mini"
        ></el-input>
      </div>
      <div class="item">
        <span class="tip">栏目:</span>
        <el-input v-model="lm" placeholder="请输入内容" size="mini"></el-input>
      </div>
      <div class="item submit">
        <el-button type="primary" size="mini" @click="submit()">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NewFeatureLine",
  props: {},
  data() {
    return {
      featureTypeOptions: [
        {
          value: "古村古道",
        },
        {
          value: "红色历史",
        },
        {
          value: "民间民俗",
        },
        {
          value: "生态山水",
        },
        {
          value: "宗教寺庙",
        },
      ],
      type: "古村古道", //分类
      resoure: "", //资源id
      name: "", //名称
      town: "", // 镇ID
      village: "", // 村ID
      location: "", //地址
      lon: 113, // 经度
      lat: 34, // 纬度
      gz: "", //规制
      lswm: "", //历史文脉
      ccfa: "", // 传承方案
      des: "", //简介
      level: 1, // 级别
      picture: "", //图片
      lm: "", // 栏目
    };
  },
  watch: {},
  computed: {
    newGeom() {
      return this.$store.state.newGeom;
    },
  },
  components: {},
  methods: {
    submit() {
      if (!this.newGeom) {
        this.$message("请绘制要素！");
        return;
      }
      if (this.name == "") {
        this.$message("要素名不能为空！");
        return;
      }
      if (this.resoure == "") {
        this.$message("资源ID不能为空！");
        return;
      }
      let options = {
        geom: this.newGeom,
        type: this.type, // 分类
        resoure: this.resoure, // 资源id
        name: this.name, // 名称
        town: this.town, // 镇ID
        village: this.village, // 村ID
        location: this.location, //地址
        lon: this.lon, // 经度
        lat: this.lat, // 纬度
        gz: this.gz, // 规制
        lswm: this.lswm, // 历史文脉
        ccfa: this.ccfa, // 传承方案
        des: this.des, // 简介
        level: this.level, // 级别
        picture: this.picture, //图片
        lm: this.lm, // 栏目
      };
      this.$axios({
        url: "/api/gis_app/culture_line/",
        method: "post",
        data: options,
      }).then((res) => {
        let { status, message } = res.data;
        if (status === 201) {
          this.$message("新增要素成功！");
          this.$store.commit("setNewGeom", "");
          this.name = "";
          this.resoure = "";
        }
      });
    },
    toggleNewFeaturePanel() {
      this.$store.commit("setNewGeom", "");
      this.$emit("toggleNewFeaturePanel", false);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less" >
.new-feaure-wrapper {
  position: absolute;
  width: 350px;
  bottom: 80px;
  top: 0;
  left: 45px;
  z-index: 999;
  background: #fff;
  overflow: auto;
  border: solid 1px #ccc;
  .title {
    font-size: 14px;
    line-height: 30px;
    padding-left: 5px;
    background: #f3f8ff;
    color: #000;
    .icon {
      margin-right: 5px;
    }
    .fa-times {
      padding: 0 5px;
      float: right;
      color: rgb(99, 96, 96);
      margin-top: 6px;
    }
    .fa-times:hover {
      cursor: pointer;
      color: rgb(22, 21, 21);
    }
  }
  .content {
    padding: 10px;
    overflow: auto;
    height: calc(100% - 94px);
    .item {
      margin-bottom: 10px;
      .tip {
        margin-right: 10px;
        width: 80px;
        text-align: right;
        display: inline-block;
      }
      .el-select {
        width: 200px;
      }
      .el-icon-warning-outline {
        margin-left: 10px;
      }
      .el-icon-warning-outline:hover {
        cursor: pointer;
        color: rgb(18, 230, 71);
      }
      .el-input {
        width: 200px;
      }
    }
    .submit {
      text-align: right;
      padding-right: 20px;
    }
  }
}
</style>

 